<template>
  <b-modal
    id="welcomeTrialPremiumModal"
    content-class="ax-modal-transparent"
    centered
    hide-footer
    hide-header
    hide-actions
    no-close-on-backdrop
  >
    <section class="c-modal c-modal--dark-blur c-modal--trial-premium">
      <div
        class="c-modal__dialog"
      >
        <section class="c-modal__header text-center">
          <h3 class="w-bold fs-25 white">
            ¡Bienvenido a PREMIUM!
          </h3>
        </section>
        <section
          class="p-4">
          <div class="d-flex flex-column align-items-center text-center">
            <p class="mb-5 medium-gray">
              Tienes
              <span class="w-bold white">15 días de prueba</span>
              para disfrutar de
              <span class="w-bold white">20 lecciones</span>
              por día en cualquier curso. Luego del periodo de prueba podrás
              disfrutar de lecciones ilimitadas todos los días.
            </p>

            <button
              @click="startCourse()"
              class="c-button c-button--primary"
            >
              ¡Comenzar ahora!
            </button>
          </div>
        </section>
      </div>
    </section>
  </b-modal>
</template>

<script>
export default {
  props: {
    enroll: Object,
  },
  computed: {
    isFirstTimeModal() {
      return this.enroll.data.trial && this.enroll.data.trial.is_first_time;
    },
  },
  mounted() {
    if (this.isFirstTimeModal) {
      this.$bvModal.show('welcomeTrialPremiumModal');
    }
  },
  methods: {
    startCourse() {
      this.$bvModal.hide('welcomeTrialPremiumModal');
    },
  },
};
</script>
